// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"build_node_index_js":"e2e1b9d612b2f6a1c551978bf4be8af4d04e6f01f6f4f5cc2a887dd8649d8f69","node_modules_react_index_js":"c23e97569ec60039e5f5b1b1a4e1d1d8a941192e8bf8c3e6bb9e80d926d897da"}[chunkId] + ".js";
};